export enum ECountry {
  "DEUTSCHLAND (D)",
  "ANDORRA (AD)",
  "VEREINIGTE ARABISCHE EMIRATE (AE)",
  "AFGHANISTAN (AF)",
  "ANTIGUA UND BARBUDA (AG)",
  "ANGUILLA (AI)",
  "ALBANIEN (AL)",
  "ARMENIEN (AM)",
  "NIEDERLÄNDISCHE ANTILLEN (AN)",
  "ANGOLA (AO)",
  "ANTARKTIS (AQ)",
  "ARGENTINIEN (AR)",
  "AMERIKANISCH-SAMOA (AS)",
  "ÖSTERREICH (AT)",
  "AUSTRALIEN (AU)",
  "ARUBA (AW)",
  "ALAND (AX)",
  "ASERBAIDSCHAN (AZ)",
  "BOSNIEN UND HERZEGOWINA (BA)",
  "BARBADOS (BB)",
  "BANGLADESCH (BD)",
  "BELGIEN (BE)",
  "BURKINA FASO (BF)",
  "BULGARIEN (BG)",
  "BAHRAIN (BH)",
  "BURUNDI (BI)",
  "BENIN (BJ)",
  "SAINT BARTHÉLEMY (BL)",
  "BERMUDA (BM)",
  "BRUNEI DARUSSALAM (BN)",
  "PLURINATIONALER STAAT BOLIVIEN (BO)",
  "BONAIRE, ST EUSTATIUS UND SABA (BQ)",
  "BRASILIEN (BR)",
  "BAHAMAS (BS)",
  "BHUTAN (BT)",
  "BOUVETINSEL (BV)",
  "BOTSUANA (BW)",
  "BELARUS (BY)",
  "BELIZE (BZ)",
  "KANADA (CA)",
  "KOKOSINSELN (KEELINGINSELN) (CC)",
  "KONGO, DEMOKRATISCHE REPUBLIK (CD)",
  "ZENTRALAFRIKANISCHE REPUBLIK (CF)",
  "KONGO (CG)",
  "SCHWEIZ (CH)",
  "CÔTE D'IVOIRE (CI)",
  "COOKINSELN (CK)",
  "CHILE (CL)",
  "KAMERUN (CM)",
  "CHINA (CN)",
  "KOLUMBIEN (CO)",
  "COSTA RICA (CR)",
  "SERBIEN UND MONTENEGRO (CS)",
  "KUBA (CU)",
  "KAP VERDE (CV)",
  "CURAÇAO (CW)",
  "WEIHNACHTSINSEL (CX)",
  "ZYPERN (CY)",
  "TSCHECHISCHE REPUBLIK (CZ)",
  "CUNHA (DA)",
  "DSCHIBUTI (DJ)",
  "DÄNEMARK (DK)",
  "DOMINICA (DM)",
  "DOMINIKANISCHE REPUBLIK (DO)",
  "ALGERIEN (DZ)",
  "ECUADOR (EC)",
  "ESTLAND (EE)",
  "ÄGYPTEN (EG)",
  "WESTSAHARA (EH)",
  "ERITREA (ER)",
  "SPANIEN (ES)",
  "ÄTHIOPIEN (ET)",
  "FINNLAND (FI)",
  "FIDSCHI (FJ)",
  "FALKLANDINSELN (MALWINEN) (FK)",
  "FÖDERIERTE STAATEN VON MIKRONESIEN (FM)",
  "FÄRÖER (FO)",
  "FRANKREICH (FR)",
  "GABUN (GA)",
  "GROSSBRITANNIEN (GB)",
  "GRENADA (GD)",
  "GEORGIEN (GE)",
  "FRANZÖSISCH-GUAYANA (GF)",
  "GUERNSEY (GG)",
  "GHANA (GH)",
  "GIBRALTAR (GI)",
  "GRÖNLAND (GL)",
  "GAMBIA (GM)",
  "GUINEA (GN)",
  "GUADELOUPE (GP)",
  "ÄQUATORIALGUINEA (GQ)",
  "GRIECHENLAND (GR)",
  "SÜDGEORGIEN UND DIE SÜDLICHEN SANDWICHINSELN (GS)",
  "GUATEMALA (GT)",
  "GUAM (GU)",
  "GUINEA-BISSAU (GW)",
  "GUYANA (GY)",
  "HONGKONG (HK)",
  "HEARD UND DIE MCDONALDINSELN (HM)",
  "HONDURAS (HN)",
  "KROATIEN (HR)",
  "HAITI (HT)",
  "UNGARN (HU)",
  "INDONESIEN (ID)",
  "IRLAND (IE)",
  "ISRAEL (IL)",
  "ISLE OF MAN (IM)",
  "INDIEN (IN)",
  "BRITISCHES TERRITORIUM IM INDISCHEN OZEAN (IO)",
  "IRAK (IQ)",
  "ISLAMISCHE REPUBLIK IRAN (IR)",
  "ISLAND (IS)",
  "ITALIEN (IT)",
  "JERSEY (JE)",
  "JAMAIKA (JM)",
  "JORDANIEN (JO)",
  "JAPAN (JP)",
  "KENIA (KE)",
  "KIRGISISCHE REPUBLIK (KG)",
  "KAMBODSCHA (KH)",
  "KIRIBATI (KI)",
  "KOMOREN (KM)",
  "ST. KITTS UND NEVIS (KN)",
  "KOREA, DEMOKRATISCHE VOLKSREPUBLIK (KP)",
  "REPUBLIK KOREA (KR)",
  "KUWAIT (KW)",
  "KAIMANINSELN (KY)",
  "KASACHSTAN (KZ)",
  "LAOS, DEMOKRATISCHE VOLKSREPUBLIK (LA)",
  "LIBANON (LB)",
  "ST. LUCIA (LC)",
  "LIECHTENSTEIN (LI)",
  "SRI LANKA (LK)",
  "LIBERIA (LR)",
  "LESOTHO (LS)",
  "LITAUEN (LT)",
  "LUXEMBURG (LU)",
  "LETTLAND (LV)",
  "LIBYEN (LY)",
  "MAROKKO (MA)",
  "MONACO (MC)",
  "REPUBLIK MOLDAU (MD)",
  "MONTENEGRO (ME)",
  "ST. MARTIN (MF)",
  "MADAGASKAR (MG)",
  "MARSHALLINSELN (MH)",
  "EHEMALIGE JUGOSLAWISCHE REPUBLIK MAZEDONIEN (MK)",
  "MALI (ML)",
  "MYANMAR (MM)",
  "MONGOLEI (MN)",
  "MACAU (MO)",
  "NÖRDLICHE MARIANEN (MP)",
  "MARTINIQUE (MQ)",
  "MAURETANIEN (MR)",
  "MONTSERRAT (MS)",
  "MALTA (MT)",
  "MAURITIUS (MU)",
  "MALEDIVEN (MV)",
  "MALAWI (MW)",
  "MEXIKO (MX)",
  "MALAYSIA (MY)",
  "MOSAMBIK (MZ)",
  "NAMIBIA (NA)",
  "NEUKALEDONIEN (NC)",
  "NIGER (NE)",
  "NORFOLKINSEL (NF)",
  "NIGERIA (NG)",
  "NICARAGUA (NI)",
  "NIEDERLANDE (NL)",
  "NORWEGEN (NO)",
  "NEPAL (NP)",
  "NAURU (NR)",
  "NIUE (NU)",
  "NEUSEELAND (NZ)",
  "OMAN (OM)",
  "PANAMA (PA)",
  "PERU (PE)",
  "FRANZÖSISCH-POLYNESIEN (PF)",
  "PAPUA-NEUGUINEA (PG)",
  "PHILIPPINEN (PH)",
  "PAKISTAN (PK)",
  "POLEN (PL)",
  "ST. PIERRE UND MIQUELON (PM)",
  "PITCAIRN (PN)",
  "PUERTO RICO (PR)",
  "BESETZTE PALÄSTINENSISCHE GEBIETE (PS)",
  "PORTUGAL (PT)",
  "PALAU (PW)",
  "PARAGUAY (PY)",
  "KATAR (QA)",
  "RÉUNION (RE)",
  "RUMÄNIEN (RO)",
  "SERBIEN (RS)",
  "RUSSISCHE FÖDERATION (RU)",
  "RUANDA (RW)",
  "SAUDI-ARABIEN (SA)",
  "SALOMONEN (SB)",
  "SEYCHELLEN (SC)",
  "SUDAN (SD)",
  "SCHWEDEN (SE)",
  "SINGAPUR (SG)",
  "ST. HELENA, ASCENSION UND TRISTAN (SH)",
  "SLOWENIEN (SI)",
  "SVALBARD UND JAN MAYEN (SJ)",
  "SLOWAKEI (SK)",
  "SIERRA LEONE (SL)",
  "SAN MARINO (SM)",
  "SENEGAL (SN)",
  "SOMALIA (SO)",
  "SURINAME (SR)",
  "SÜDSUDAN (SS)",
  "SÃO TOMÉ UND PRÍNCIPE (ST)",
  "EL SALVADOR (SV)",
  "ST. MARTIN (NIEDERLÄNDISCHER TEIL) (SX)",
  "ARABISCHE REPUBLIK SYRIEN (SY)",
  "SWASILAND (SZ)",
  "TURKS- UND CAICOSINSELN (TC)",
  "TSCHAD (TD)",
  "FRANZÖSISCHE SÜD- UND ANTARKTISGEBIETE (TF)",
  "TOGO (TG)",
  "THAILAND (TH)",
  "TADSCHIKISTAN (TJ)",
  "TOKELAU (TK)",
  "TIMOR-LESTE (TL)",
  "TURKMENISTAN (TM)",
  "TUNESIEN (TN)",
  "TONGA (TO)",
  "TÜRKEI (TR)",
  "TRINIDAD UND TOBAGO (TT)",
  "TUVALU (TV)",
  "TAIWAN (TW)",
  "VEREINIGTE REPUBLIK TANSANIA (TZ)",
  "UKRAINE (UA)",
  "UGANDA (UG)",
  "KLEINERE AMERIKANISCHE ÜBERSEEINSELN (UM)",
  "VEREINIGTE STAATEN VON AMERIKA (US)",
  "URUGUAY (UY)",
  "USBEKISTAN (UZ)",
  "VATIKANSTADT (VA)",
  "ST. VINCENT UND DIE GRENADINEN (VC)",
  "BOLIVARISCHE REPUBLIK VENEZUELA (VE)",
  "BRITISCHE JUNGFERNINSELN (VG)",
  "AMERIKANISCHE JUNGFERNINSELN (VI)",
  "VIETNAM (VN)",
  "VANUATU (VU)",
  "WALLIS UND FUTUNA (WF)",
  "SAMOA (WS)",
  "CEUTA (XC)",
  "KOSOVO (XK)",
  "MELILLA (XL)",
  "JEMEN (YE)",
  "MAYOTTE (YT)",
  "SÜDAFRIKA (ZA)",
  "SAMBIA (ZM)",
  "SIMBABWE (ZW)",
}
